//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { ImageWithErrorHandling } from '@components/atoms/image-with-error-handling/ImageWithErrorHandling';
import { CenteredSpinner } from '@components/atoms/spinner/Spinner';
import { SectionText } from '@components/atoms/text/Text';
import Cuid from '@models/Cuid';
import { useMediaMetadataQuery } from '@uia/details/hooks/useMediaMetadataQuery';
import { isDefined } from '@utils/filterPredicates';

export interface UIACustomCoverImageProps {
  cuid: Cuid;
}

export const UIACustomCoverImage = ({ cuid }: UIACustomCoverImageProps) => {
  const { data: metadata, isError, isLoading } = useMediaMetadataQuery(cuid);

  return (
    <CoverImageWrapper>
      <SectionText>Gallery Cover Image</SectionText>
      {isError && (
        <div>
          An unexpected error occurred. Please try again or contact Bazaarvoice
          Support.
        </div>
      )}
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <>
          {isDefined(metadata) && (
            <CoverImageContainer>
              <ImageWithErrorHandling
                alt='Cover Image'
                src={metadata.thumbnailUrl}
              />
            </CoverImageContainer>
          )}
        </>
      )}
    </CoverImageWrapper>
  );
};

const CoverImageWrapper = styled.div(
  ({ theme }) => `
    padding: ${theme.spacings[3]};
  `,
);

const CoverImageContainer = styled.div(
  ({ theme }) => `
    margin-top: ${theme.spacings[3]};
    display: flex;
    justify-content: center;
  `,
);
